import { useBlockProps } from '@wordpress/block-editor'
import React from 'react'
import ServerSideRender from './ServerSideRender'
import { BlockEditProps } from '@wordpress/blocks'

export default function DefaultEditor(props: BlockEditProps<{}>) {
  return (
    <div {...useBlockProps()}>
      <ServerSideRender {...props} />
    </div>
  )
}
